import React, { memo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useLazyQuery, useQuery } from '@apollo/client';
import AdvanceSelectLabel from '../advance-select/advance-select-label';
import { getIncoTerm, getTransportList } from '../../graphQL/addAddress';
import TextBox from '../text-box/text-box';
import './addOrderLines.scss';
import { getDigitsOnly } from '../../helpers/utils';

function AddShipment({
  mode,
  shipmentType,
  setMode,
  setShipmentType,
  containerType,
  setContainerType,
  typeOfMove,
  setTypeOfMove,
  equipmentType,
  setEquipmentType,
  truckType,
  setTruckType,
  equipTypeQty,
  setEquipTypeQty,
  incoTerm,
  setIncoTerm,
  setNumberOfTrucks,
  numberOfTrucks,
  cargoLoad,
  setCargoLoad,
  changeMode,
  disableMode,
  disableType,
  totalWeight,
  weightUnit,
  setTotalWeight,
  setWeightUnit,
  consigneeId,
  isConsoliatedBooking,
  modeSelectionConsole,
  isConsole,
  setAirFreType,
  airFreType,
  bulkIncoTerm,
  serviceLevel,
  setServiceLevel,
}) {
  const [t] = useTranslation('manageorders');
  // const [incoTermList] = useLazyQuery(getIncoTerm);
  const [transportList] = useLazyQuery(getTransportList);

  // Due to useTranslation, static options cannot be globally declared
  const typeOfMoveOptions = [
    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.typeOfMoveOptions.port to port'
      ),
      value: 'port to port',
    },
    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.typeOfMoveOptions.port to door'
      ),
      value: 'port to door',
    },
    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.typeOfMoveOptions.door to port'
      ),
      value: 'door to port',
    },
    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.typeOfMoveOptions.door to door'
      ),
      value: 'door to door',
    },
  ];

  const modeOptions = [
    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.modeOptions.Ocean'
      ),
      value: 'Ocean',
    },
    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.modeOptions.Air'
      ),
      value: 'Air',
    },
    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.modeOptions.Inland'
      ),
      value: 'Inland',
    },
  ];

  const shipTypeOptions = [
    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.shipmentTypeOptions.Domestic'
      ),
      value: 'Domestic',
    },

    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.shipmentTypeOptions.Export'
      ),
      value: 'Export',
    },
    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.shipmentTypeOptions.Import'
      ),
      value: 'Import',
    },
  ];

  const weightUnitOptions = [
    { label: 'Kgs', value: 'Kgs' },
    { label: 'Lbs', value: 'Lbs' },
  ];

  const serviceLevelOptions = [
    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.serviceLevelOptions.Standard'
      ),
      value: 'standard',
    },
    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.serviceLevelOptions.Express'
      ),
      value: 'express',
    },
    {
      label: t(
        'manageordersscreen.createbookingmenu.shipmentdetails.serviceLevelOptions.Economy'
      ),
      value: 'economy',
    },
  ];

  const [options, setOptions] = useState([]);
  const [incoTermOptions, setIncoTermOptions] = useState([]);
  const [transportOptions, setTransportOptions] = useState([]);
  const [shipmentTypeOptions, setShipmentTypeOptions] = useState([]);

  useEffect(() => {
    if (mode.value === 'Ocean') {
      setOptions([
        { label: 'FCL', value: 'FCL' },
        { label: 'LCL', value: 'LCL' },
      ]);
      setShipmentTypeOptions(
        shipTypeOptions?.filter((opt) => opt?.value !== 'Domestic')
      );
    } else if (mode.value === 'Air') {
      setOptions([{ label: 'AIR', value: 'AIR' }]);
      setShipmentTypeOptions(
        shipTypeOptions?.filter((opt) => opt?.value !== 'Domestic')
      );
    } else {
      setOptions([
        { label: 'FTL', value: 'FTL' },
        { label: 'LTL', value: 'LTL' },
      ]);
      setShipmentTypeOptions(shipTypeOptions);
    }
  }, [mode]);

  // need to move this api call at parent
  const transportServerCall = () => {
    transportList({
      variables: {
        input: {
          type: mode?.value === 'Ocean' ? 'Ocean' : 'Inland',
        },
      },
      onCompleted: (data) => {
        setTransportOptions(data?.fetchTransportList?.data);
      },
      // fetchPolicy: 'cache-first',
    });
  };

  // const serverCall = () => {
  //   incoTermList({
  //     variables: {},
  //     fetchPolicy: 'cache-first',
  //     onCompleted: (data) => {
  //       const incoTermOption = [];
  //       setIncoTermOptions([]);

  //       data?.FetchIncoterm?.data.map((item) => {
  //         incoTermOption.push({
  //           label: item.Abbreviation,
  //           value: item.Abbreviation,
  //           mode: item.Mode,
  //         });

  //         return '';
  //       });
  //       setIncoTermOptions(incoTermOption);
  //     },
  //   });
  // };

  // useEffect(() => {
  //   serverCall();
  // }, []);

  useQuery(getIncoTerm, {
    variables: {},
    // fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      const incoTermOption = [];
      setIncoTermOptions([]);

      data?.FetchIncoterm?.data.map((item) => {
        incoTermOption.push({
          label: item.Abbreviation,
          value: item.Abbreviation,
          mode: item.Mode,
        });

        return '';
      });
      setIncoTermOptions(incoTermOption);
    },
  });

  useEffect(() => {
    if (mode?.value && mode?.value !== 'Air') {
      transportServerCall();
    }
  }, [mode.value]);

  // rename
  const opts = transportOptions?.map((item) => {
    const valueKey = mode.value === 'Ocean' ? 'equipmentType' : 'truckType';
    return {
      ...item,
      label: item[valueKey],
      value: item[valueKey],
    };
  });

  // Function to limit the value to two decimal places
  const handleChange = (e) => {
    const inputValue = e.target.value;

    // Regular expression to match numbers with up to two decimal places
    const decimalRegex = /^[0-9]*\.?[0-9]{0,2}$/;

    if (decimalRegex.test(inputValue)) {
      setTotalWeight(inputValue);
    }
  };
  useEffect(() => {
    if (isConsole) {
      setMode({
        label: t(
          `manageordersscreen.createbookingmenu.shipmentdetails.modeOptions.${modeSelectionConsole}`
        ),
        value: modeSelectionConsole,
      });
      if (Object.keys(typeOfMove).length === 0) {
        setTypeOfMove({
          label: t(
            'manageordersscreen.createbookingmenu.shipmentdetails.typeOfMoveOptions.door to port'
          ),
          value: 'door to port',
        });
      }
    }
  }, [isConsole]);

  return (
    <>
      {consigneeId && (
        <>
          <div className="select-container multi-box">
            <div className="value">
              <TextBox
                id="weight"
                name="weight"
                type="number"
                min={0}
                label={t(
                  'manageordersscreen.createbookingmenu.shipmentdetails.totalweight'
                )}
                required
                value={totalWeight}
                placeholder={t(
                  'manageordersscreen.createbookingmenu.shipmentdetails.totalweightplaceholder'
                )}
                defaultValue={totalWeight}
                onChange={(e) => {
                  handleChange(e);
                }}
                onPaste={(e) => {
                  e.preventDefault(); // Prevent the default paste action
                  const pastedValue = e.clipboardData.getData('text');
                  if (/^\d*\.?\d*$/.test(pastedValue)) {
                    const [integerPart, decimalPart] = pastedValue.split('.');
                    const sanitizedValue = decimalPart
                      ? `${integerPart}.${decimalPart.slice(0, 2)}`
                      : integerPart;
                    e.target.value = sanitizedValue;
                    e.target.dispatchEvent(
                      new Event('input', { bubbles: true })
                    ); // Trigger React change
                  }
                  setTotalWeight(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (
                    e.key === 'e' ||
                    e.key === 'E' ||
                    e.key === '-' ||
                    e.key === '+'
                  ) {
                    e.preventDefault();
                  }
                }}
              />
            </div>

            <div className="unit">
              <AdvanceSelectLabel
                name="weightUnit"
                id="weightUnit"
                required
                defaultValue={
                  weightUnit?.value
                    ? weightUnit
                    : // : weightUnitOptions?.find((opt) => opt?.value === 'Kgs')
                      { label: '', value: '' }
                }
                onChange={(e) => {
                  setWeightUnit({
                    label: e?.target?.nextSibling?.innerHTML,
                    value: e?.target?.value,
                  });
                }}
                removeSelectedValue={() => {
                  setWeightUnit({ label: '', value: '' });
                }}
                data={weightUnitOptions}
              />
            </div>
          </div>
          {/* Shipment Frequency hidden for now
          <div className="select-container">
            <AdvanceSelectLabel
              name="shipmentFrequency"
              id="shipmentFrequency"
              required
              defaultValue={shipmentFrequency}
              placeholder={t(
                'manageordersscreen.createbookingmenu.shipmentdetails.shipmentfrequencyplaceholder'
              )}
              label={t(
                'manageordersscreen.createbookingmenu.shipmentdetails.shipmentfrequency'
              )}
              onChange={(e) => {
                setShipmentFrequency({
                  label: e?.target?.nextSibling?.innerHTML,
                  value: e?.target?.value,
                });
              }}
              removeSelectedValue={() => {
                setShipmentFrequency({ label: '', value: '' });
              }}
              data={[
                { label: 'Spot-Rate', value: 'Spot-Rate' },
                { label: 'Project', value: 'Project', disabled: true },
              ]}
            />
          </div>
          */}
        </>
      )}
      <div className="select-container">
        <AdvanceSelectLabel
          // forceValue={mode?.label}
          name="mode"
          id="mode"
          onChange={(e) => {
            if (e?.target?.value !== mode?.value) {
              setMode({
                label: t(
                  `manageordersscreen.createbookingmenu.shipmentdetails.modeOptions.${e?.target?.value}`
                ),
                value: e?.target?.value,
              });
            }
            if (
              shipmentType?.value === 'Domestic' &&
              e?.target?.value !== 'Inland'
            ) {
              setShipmentType({ label: '', value: '' });
            }
          }}
          removeSelectedValue={() => {
            if (mode?.value) {
              changeMode('mode');
            }
          }}
          placeholder={t(
            'manageordersscreen.createbookingmenu.shipmentdetails.shipmentmodeplaceholder'
          )}
          label={t(
            'manageordersscreen.createbookingmenu.shipmentdetails.shipmentmode'
          )}
          required
          data={modeOptions}
          value={mode}
          defaultValue={mode}
          disabled={disableMode || isConsoliatedBooking || isConsole}
        />
      </div>

      {(mode?.value === 'Air' || mode?.value === 'Inland') && (
        <div className="select-container">
          <AdvanceSelectLabel
            name="serviceLevel"
            id="serviceLevel"
            required={false}
            defaultValue={
              serviceLevel?.value
                ? serviceLevel
                : {
                    label: t(
                      'manageordersscreen.createbookingmenu.shipmentdetails.serviceLevelOptions.Standard'
                    ),
                    value: 'standard',
                  }
            }
            value={serviceLevel}
            placeholder={t(
              'manageordersscreen.createbookingmenu.shipmentdetails.SelectServiceLevel'
            )}
            label={t(
              'manageordersscreen.createbookingmenu.shipmentdetails.ServiceType'
            )}
            data={serviceLevelOptions}
            onChange={(e) => {
              setServiceLevel({
                label: e?.target?.nextSibling?.innerHTML,
                value: e?.target?.value,
              });
            }}
            removeSelectedValue={() => {
              setServiceLevel({
                label: t(
                  'manageordersscreen.createbookingmenu.shipmentdetails.serviceLevelOptions.Standard'
                ),
                value: 'standard',
              });
            }}
          />
        </div>
      )}

      <div className="select-container">
        <AdvanceSelectLabel
          name="shipmentType"
          id="shipmentType"
          onChange={(e) => {
            if (e?.target?.value !== shipmentType?.value) {
              setShipmentType({
                label: t(
                  `manageordersscreen.createbookingmenu.shipmentdetails.shipmentTypeOptions.${e?.target?.value}`
                ),
                value: e?.target?.value,
              });
            }
          }}
          removeSelectedValue={() => {
            if (shipmentType?.value) {
              changeMode('shipmentType');
            }
            setShipmentType({ label: '', value: '' });
          }}
          placeholder={t(
            'manageordersscreen.createbookingmenu.shipmentdetails.shipmentTypePlaceholder'
          )}
          label={t(
            'manageordersscreen.createbookingmenu.shipmentdetails.shipmentType'
          )}
          required
          data={shipmentTypeOptions}
          value={shipmentType}
          defaultValue={shipmentType}
          disabled={disableType}
        />
      </div>

      <div className="select-container">
        <AdvanceSelectLabel
          name="typeOfMove"
          id="typeOfMove"
          required
          defaultValue={typeOfMove}
          onChange={(e) => {
            setTypeOfMove({
              label: t(
                `manageordersscreen.createbookingmenu.shipmentdetails.typeOfMoveOptions.${e?.target?.value}`
              ),
              value: e?.target?.value,
            });
          }}
          removeSelectedValue={() => {
            setTypeOfMove({ label: '', value: '' });
          }}
          placeholder={t(
            'manageordersscreen.createbookingmenu.shipmentdetails.typeofmoveplaceholder'
          )}
          label={t(
            'manageordersscreen.createbookingmenu.shipmentdetails.typeofmove'
          )}
          data={typeOfMoveOptions}
          disabled={mode?.value === 'Inland' || isConsoliatedBooking}
        />
      </div>
      {shipmentType?.value !== 'Domestic' && !isConsoliatedBooking && (
        <div className="select-container">
          <AdvanceSelectLabel
            name="incoTerm"
            id="incoTerm"
            required={shipmentType?.value !== 'Domestic'}
            defaultValue={incoTerm}
            placeholder={t(
              'manageordersscreen.createbookingmenu.shipmentdetails.incotermplaceholder'
            )}
            label={t(
              'manageordersscreen.createbookingmenu.shipmentdetails.incoterm'
            )}
            onChange={(e) => {
              setIncoTerm({
                label: e?.target?.nextSibling?.innerHTML,
                value: e?.target?.value,
              });
            }}
            removeSelectedValue={() => {
              setIncoTerm({ label: '', value: '' });
            }}
            data={
              mode?.value === 'Air'
                ? incoTermOptions.filter((item) => {
                    return item.mode === 'All';
                  })
                : incoTermOptions
            }
            // Disable incoterm is isConsoleBulkVitro and incoterm is pre-assigned
            disabled={bulkIncoTerm}
          />
        </div>
      )}
      {mode?.value === 'Air' && isConsole && (
        <div className="select-container">
          <AdvanceSelectLabel
            name="airFreType"
            id="airFreType"
            required
            defaultValue={airFreType}
            placeholder={t(
              'manageordersscreen.createbookingmenu.shipmentdetails.airfreighttypeplace'
            )}
            label={t(
              'manageordersscreen.createbookingmenu.shipmentdetails.airfreighttype'
            )}
            onChange={(e) => {
              setAirFreType({
                label: e?.target?.nextSibling?.innerHTML,
                value: e?.target?.value,
              });
            }}
            removeSelectedValue={() => {
              setAirFreType({ label: '', value: '' });
            }}
            data={[
              {
                label: 'Premium',
                value: 'premium',
              },
              {
                label: 'Flagship',
                value: 'flagship',
              },
              {
                label: 'Economy',
                value: 'economy',
              },
              {
                label: 'Courier ( 2nd Phase )',
                value: 'courier_2nd_phase',
              },
            ]}
          />
        </div>
      )}
      {(mode?.value === 'Ocean' || mode?.value === 'Inland') && (
        <div className="select-container">
          <AdvanceSelectLabel
            id={mode?.value === 'Ocean' ? 'containerType' : 'cargoLoad'}
            name={mode?.value === 'Ocean' ? 'containerType' : 'cargoLoad'}
            data={options}
            required
            onChange={(e) => {
              if (mode?.value === 'Ocean') {
                setContainerType({
                  label: e?.target?.nextSibling?.innerHTML,
                  value: e?.target?.value,
                });
              } else {
                setCargoLoad({
                  label: e?.target?.nextSibling?.innerHTML,
                  value: e?.target?.value,
                });
              }
              setEquipmentType({});
              setTruckType({ label: '', value: '' });
              setEquipTypeQty(1);
              setNumberOfTrucks(1);
            }}
            removeSelectedValue={() => {
              if (mode?.value === 'Ocean') {
                setContainerType({ label: '', value: '' });
              } else {
                setCargoLoad({ label: '', value: '' });
              }
              setEquipmentType({});
              setEquipTypeQty(1);
              setNumberOfTrucks(1);
            }}
            placeholder={
              mode?.value === 'Ocean'
                ? t(
                    'manageordersscreen.createbookingmenu.shipmentdetails.oceanplaceholder'
                  )
                : t(
                    'manageordersscreen.createbookingmenu.shipmentdetails.roadplaceholder'
                  )
            }
            label={
              mode?.value === 'Ocean'
                ? t(
                    'manageordersscreen.createbookingmenu.shipmentdetails.containertype'
                  )
                : t(
                    'manageordersscreen.createbookingmenu.shipmentdetails.cargoload'
                  )
            }
            defaultValue={mode?.value === 'Ocean' ? containerType : cargoLoad}
            // isReadOnly
          />
        </div>
      )}
      {mode?.value === 'Ocean' && containerType.value === 'FCL' && (
        <div className="select-container d-flex justify-between align-end">
          <AdvanceSelectLabel
            id="equipmentType"
            name="equipmentType"
            required
            className="w-100"
            defaultValue={equipmentType}
            onChange={(e) => {
              setEquipmentType({
                label: e?.target?.nextSibling?.innerHTML,
                value: e.target.value,
              });
            }}
            removeSelectedValue={() => {
              setEquipmentType({ label: '', value: '' });
            }}
            placeholder={t(
              'manageordersscreen.createbookingmenu.shipmentdetails.equipmenttypeplaceholder'
            )}
            label={t(
              'manageordersscreen.createbookingmenu.shipmentdetails.equipmenttype'
            )}
            data={opts}
            // isReadOnly
          />
          {mode?.value !== 'Inland' && (
            <>
              <span className="mb-15 mx-5">X</span>
              <TextBox
                type="number"
                label={t(
                  'manageordersscreen.createbookingmenu.shipmentdetails.qty'
                )}
                width="4.444vw"
                required
                defaultValue={equipTypeQty}
                placeholder={t(
                  'manageordersscreen.createbookingmenu.shipmentdetails.qtyplaceholder'
                )}
                onChange={(e) => setEquipTypeQty(e.target.value)}
                onKeyDown={(e) => {
                  getDigitsOnly(e);
                }}
              />
            </>
          )}
        </div>
      )}
      {mode?.value === 'Inland' && cargoLoad?.value === 'FTL' && (
        <div className="select-container d-flex justify-between align-end">
          <AdvanceSelectLabel
            id="truckType"
            name="truckType"
            required
            className="w-100"
            defaultValue={truckType}
            onChange={(e) => {
              setTruckType({
                label: e?.target?.nextSibling?.innerHTML,
                value: e.target.value,
              });
            }}
            removeSelectedValue={() => {
              setTruckType({ label: '', value: '' });
            }}
            placeholder={t(
              'manageordersscreen.createbookingmenu.shipmentdetails.trucktypeplaceholder'
            )}
            label={t(
              'manageordersscreen.createbookingmenu.shipmentdetails.trucktype'
            )}
            data={opts}
          />
          <span className="mb-15 mx-5">X</span>
          <TextBox
            type="number"
            label={t(
              'manageordersscreen.createbookingmenu.shipmentdetails.qty'
            )}
            required
            placeholder={t(
              'manageordersscreen.createbookingmenu.shipmentdetails.qtyplaceholder'
            )}
            defaultValue={numberOfTrucks}
            onChange={(e) => setNumberOfTrucks(e.target.value)}
            onKeyDown={(e) => {
              getDigitsOnly(e);
            }}
          />
        </div>
      )}
    </>
  );
}
AddShipment.propTypes = {
  mode: PropTypes.instanceOf(Object),
  shipmentType: PropTypes.instanceOf(Object),
  setMode: PropTypes.func,
  setShipmentType: PropTypes.func,
  changeMode: PropTypes.func,
  containerType: PropTypes.instanceOf(Object),
  setContainerType: PropTypes.func,
  typeOfMove: PropTypes.instanceOf(Object),
  setTypeOfMove: PropTypes.func,
  equipmentType: PropTypes.instanceOf(Object),
  equipTypeQty: PropTypes.number,
  setEquipTypeQty: PropTypes.func,
  setEquipmentType: PropTypes.func,
  truckType: PropTypes.instanceOf(Object),
  setTruckType: PropTypes.func,
  incoTerm: PropTypes.instanceOf(Object),
  setIncoTerm: PropTypes.func,
  setNumberOfTrucks: PropTypes.func,
  numberOfTrucks: PropTypes.number,
  cargoLoad: PropTypes.instanceOf(Object),
  setCargoLoad: PropTypes.func,
  disableMode: PropTypes.bool,
  disableType: PropTypes.bool,
  totalWeight: PropTypes.number,
  weightUnit: PropTypes.instanceOf(Object),
  setTotalWeight: PropTypes.func,
  setWeightUnit: PropTypes.func,
  consigneeId: PropTypes.number,
  isConsoliatedBooking: PropTypes.bool,
  modeSelectionConsole: PropTypes.string,
  isConsole: PropTypes.bool,
  setAirFreType: PropTypes.func,
  airFreType: PropTypes.string,
  bulkIncoTerm: PropTypes.string,
  serviceLevel: PropTypes.instanceOf(Object),
  setServiceLevel: PropTypes.func,
};
AddShipment.defaultProps = {
  mode: {},
  shipmentType: {},
  setMode: () => {},
  setShipmentType: () => {},
  changeMode: () => {},
  containerType: {},
  setContainerType: () => {},
  typeOfMove: {},
  setTypeOfMove: () => {},
  equipmentType: {},
  setEquipmentType: () => {},
  truckType: {},
  setTruckType: () => {},
  equipTypeQty: 1,
  setEquipTypeQty: () => {},
  incoTerm: {},
  setIncoTerm: () => {},
  numberOfTrucks: 1,
  setNumberOfTrucks: () => {},
  cargoLoad: {},
  setCargoLoad: () => {},
  disableMode: false,
  disableType: false,
  totalWeight: null,
  weightUnit: {},
  setTotalWeight: () => {},
  setWeightUnit: () => {},
  consigneeId: null,
  isConsoliatedBooking: false,
  modeSelectionConsole: '',
  isConsole: false,
  setAirFreType: () => {},
  airFreType: '',
  bulkIncoTerm: '',
  serviceLevel: {},
  setServiceLevel: () => {},
};
export default memo(AddShipment);
